export enum LoginType {
  Popup,
  Redirect,
}
